import PropTypes from 'prop-types';
import React from 'react';
import useOTPInput from '../../hooks/useOTPInput'; // Import the hook
import { LoadingSpinner } from '../ui/loading-spinner.tsx';

export default function OTPInput({ onComplete, isLoading = false, error = '' }) {
  const { otp, inputRefs, handleChange, handleKeyDown, handlePaste } = useOTPInput(onComplete); // Initialize the OTP input handler

  return (
    <div className="space-y-4">
      <div className="flex justify-center gap-2">
        {otp.map((digit, index) => (
          <input
            key={index}
            ref={el => inputRefs.current[index] = el}
            type="text"
            inputMode="numeric"
            maxLength={1}
            value={digit}
            onChange={e => handleChange(index, e.target.value)}
            onKeyDown={e => handleKeyDown(index, e)}
            onPaste={handlePaste}
            disabled={isLoading}
            className={`w-12 h-12 text-center text-xl font-semibold border rounded-lg 
              focus:border-purple-500 focus:ring-2 focus:ring-purple-200 
              disabled:bg-gray-100 disabled:cursor-not-allowed
              ${error ? 'border-red-300 focus:border-red-500 focus:ring-red-200' : 'border-gray-300'}
            `}
          />
        ))}
      </div>

      {isLoading && (
        <div className="flex justify-center items-center gap-2 text-gray-600">
          <LoadingSpinner size="sm" />
          <span>Verifying...</span>
        </div>
      )}

      {error && (
        <div className="text-red-500 text-sm text-center">
          {error}
        </div>
      )}
    </div>
  )
}

OTPInput.propTypes = {
  onComplete: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
  error: PropTypes.string
}